module.exports = __webpack_public_path__ + "img/qr_to_friend.4a64455b.png";